// Bootstrapのスタイルシート側の機能を読み込む
//import 'bootstrap/dist/css/bootstrap.min.css';

import './sass/style.scss'; //バンドルするCSSの読み込み

//JSファイルの読み込み
import './js/smooth';
import './js/scroll';
import './js/main';
import './js/slide';
import './js/swiper-custom';
import './js/mouse';

//lazyload plugin
(function () {
  new Progressive({
    el: '#main',
    lazyClass: 'lazy',
    removePreview: true,
    scale: true,
  }).fire();
})();

// BootstrapのJavaScript側の機能を読み込む
//import 'bootstrap';
//require('progressive-image');
// require('intersection-observer'); //使うプラグイン指定
// // import 'whatwg-fetch';
// window.jQuery = window.$ = require('jquery');
